import { defineStore } from "pinia";
import SystemResource from "~/models/techloaner/System";

export const useTechLoanerStore = defineStore("techloaner", {
  state: () => ({
    departments: [],
    equipment_types: [],
    locations: [],
  }),
  getters: {},
  actions: {
    async loadConfig() {
      const response = await SystemResource.$first();
      this.departments = response.departments;
      this.equipment_types = response.equipment_types;
      this.locations = response.locations;
    },

    /**
     *  Handle Changes to Related Data
     **/
    updateRelatedData(model, myKey, matchFn) {
      if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
        // Don't care about save.
        return;
      }

      const dataIndex = this[myKey].findIndex(matchFn);
      if (dataIndex == -1) {
        this[myKey].push(model);
      } else {
        this[myKey].splice(dataIndex, 1, model);
      }
    },

    removeRelatedData(model, myKey, matchFn) {
      if (typeof this[myKey] != "object" || !Array.isArray(this[myKey])) {
        // Don't care about save.
        return;
      }

      const dataIndex = this[myKey].findIndex(matchFn);
      if (dataIndex != -1) {
        this[myKey].splice(dataIndex, 1);
      }
    },
  },
});
